import { useNotificationPermission, NotificationPermission } from './useNotificationPermission';


interface UseNotificationsReturn {
  permission: NotificationPermission;
  isSupported: boolean;
  requestPermission: () => Promise<NotificationPermission>;
  isLoading: boolean;
  error: string | null;
}

export const useNotifications = (): UseNotificationsReturn => {
  const {
    permission,
    isSupported,
    requestPermission,
    isLoading,
    error
  } = useNotificationPermission();

  return {
    permission,
    isSupported,
    requestPermission,
    isLoading,
    error,
  };
}; 